import Vue from 'vue';
import router from './router';
import axios from 'axios';
import store from './store';
import utm from'./utm';
import tool from './utils/tool';
import VConsole from 'vconsole';
import App from './App.vue';
import cookies from 'js-cookie';
import pos from './pos'
import userRecord from "./userRecord";
import gzhDialog from './components/gzh-dialog';


axios.create({
    headers: {
        'Cache-Control': 'no-cache'
    }
});

if(process.env.VUE_APP_FLAG !== "pro"){
	// const vConsole = new VConsole();
}

Vue.prototype.axios = axios;
Vue.prototype.cookies = cookies;
Vue.prototype.utm = utm;
Vue.use(tool);
Vue.use(gzhDialog);



Vue.config.productionTip = false


Vue.mixin({
	data() {
		return {
			shortUrl: '',
			pageRecord:{
				module:'0元试用活动',
				category1: '',
				title: document.title
			}
		};
	},
	created() {
	},

	watch: {
		//路由变化就是刷新数据，为了解决子级跳转到这个页面，数据不刷新问题
		// '$route': {
		// 	handler() {
		// 		// 这里判断是页面再执行页面级变量 并且不是详情页时调用，因为详情页需要等接口返回具体信息再执行
		// 		if(this.constructor === Vue && this.$route.fullPath.indexOf('/detail/') === -1){
		// 			this.$nextTick(this.gioPageAction());
		// 		}
		// 	},
		// 	immediate: false
		// }
	},

	mounted() {
		// 这里判断是页面再执行
		if(this.constructor === Vue){
			setTimeout(pos.init(), 1000)

		}

	},
	methods: {
		async openQidiankefu() {

			if (!this.shortUrl) {
				this.shortUrl = await this.getShortUrl();
			}
			var seoName = this.getCookie('seoName') || '';

			// 跳转链接
			var kefuUrl = 'https://url.cn/56IglF4?_type=wpa&qidian=true'
				+ '&wpaShowItemId=123&qidian_ex1=' + this.shortUrl
				+ '&qidian_ex2='
				+ '&qidian_ex3='
				+ '&qidian_ex4=' + '0元试用活动'
				+ '&qidian_ex5=' + seoName;

			console.log('shortUrl', this.shortUrl);
			console.log('客服链接', kefuUrl);
			console.log('搜索引擎', seoName);

			gio('track', 'click_presalesConsult');  //埋点实施方案

			window.open(kefuUrl);
		},

		//获取utm
		getUtm() {
			return {
				utmUrl: this.getCookie('utmUrl') || ''
			}
		},

		getCookie(name) {
			var arr;
			var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			if (arr = document.cookie.match(reg)) {
				return decodeURIComponent(arr[2]);
			} else {
				return null;
			}
		},

		// 获取短连接
		getShortUrl() {
			return new Promise((resolve, reject) => {
				//获取cookie 中的utmUrl
				var utmObj = this.getUtm();
				var shortUrl = '';
				var url = '';
				if (utmObj.utmUrl) {
					if (window.location.search.substr(0, 1).indexOf('?') > 0) {
						url = window.location.href + '&' + decodeURIComponent(utmObj.utmUrl);
					} else {
						url = window.location.href + '?' + decodeURIComponent(utmObj.utmUrl);
					}
				} else {
					url = window.location.href;
				}
				this.axios.post('/service/url/short', {
					url: url
				}).then(data => {
					shortUrl = data.data.data;
					this.shortUrl = shortUrl;
					resolve(shortUrl);
				}).catch(e => {
					reject(e);
				})

			})
		},

		gioPageAction(option) {
			let gioParams = {
				module_pvar: option?.module || this.pageRecord?.module,
				category1_pvar: option?.category1 || this.pageRecord?.category1 || '',
				category2_pvar: option?.category2 || this.pageRecord?.category2 || '',
				category3_pvar: option?.category3 || this.pageRecord?.category3 || '',
				title_pvar: option?.title || this.pageRecord?.title || this.module,
				url_pvar: window.location.href,
				mediaSources_pvar: common.getUrlPara('mediasources'),
				linkSource_pvar: '',
				behaviorType_pvar: '浏览网页',
				behaviorResult_pvar: '浏览成功',
				eshop_Productnumber_cms: '',
				linkSourceModule_pvar: this.getCookie('linkSourceModule_pvar') || '', //页面来源栏目模块（行为数据)
				linkSourceCategory1_pvar: this.getCookie('linkSourceCategory1_pvar') || '', //页面来源二级分类（行为数据）
				linkSourceTitle_pvar: this.getCookie('linkSourceTitle_pvar') || '', //页面来源title（行为数据）
			}

			if(location.href.indexOf('www.') > -1) {
				// 正式环境才提交行为记录
				gio('page.set', gioParams);
				userRecord.pageSet(this.pageRecord)
			}else{
				console.log('测试环境行为记录参数，仅展示不提交', gioParams)
			}
		},

		// 百度推广记录token
		adTokenBd() {
			// 判断当前页面带有参数 bd_vid 且值不为空，调用接口，不重复调用
			if (!common.getUrlPara('bd_vid') || common.getCookie('adTokenBd')) return;

			var info = {
				url: location.href,
				globalUserId: common.getGlobalUserId()
			}

			if(common.isLogin()){
				info.session = common.isLogin().session;
				info.OCSESSID = common.isLogin().OCSESSID;
			}

			common.postJson('/api/account/adtoken/bd', info, function (res) {
				if(res.errCode === 0) {
					common.setCookie('adTokenBd', 1);
				}
			})
		},
	}
});

new Vue({
	router,
	store,
	propsData : {
		  test : 'test'
	},
	render: h => h(App),
}).$mount('#app')
